import React from "react";
import ItemCard from "./item_card";
import ItemRow from "./item_row";

const ItemsList = ({
  items,
  viewMode,
  selectedCategories,
  isPick5Filter,
  prices,
  isLoadingPrices,
  isInCart,
  onItemClick,
  onAddToCart,
  onRemoveFromCart,
  onCategoryClick,
  getItemQuantity
}) => {
  return (
    <div
      className={`items-container ${viewMode}`}
      key={`items-container-${selectedCategories.join(",")}`}
    >
      {items.map((item, index) =>
        viewMode === "card" ? (
          <ItemCard
            key={item.id}
            item={item}
            index={index}
            isPick5Filter={isPick5Filter}
            prices={prices}
            isLoadingPrices={isLoadingPrices}
            isInCart={isInCart}
            onItemClick={onItemClick}
            onAddToCart={onAddToCart}
            onRemoveFromCart={onRemoveFromCart}
            getItemQuantity={getItemQuantity}
          />
        ) : (
          <ItemRow
            key={item.id}
            item={item}
            isPick5Filter={isPick5Filter}
            prices={prices}
            isLoadingPrices={isLoadingPrices}
            isInCart={isInCart}
            onAddToCart={onAddToCart}
            onRemoveFromCart={onRemoveFromCart}
            onCategoryClick={onCategoryClick}
            getItemQuantity={getItemQuantity}
          />
        )
      )}
    </div>
  );
};

export default ItemsList;
